/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [friend-entry.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 07.03.20, 14:44
 */
import React from 'react';

import {WavesTooltipBounded} from "../../components/navigation/buttons/nav-buttons";
import {UserBoxedLink} from "../../components/navigation/links/nav-headlines";
import {NavigationGroup, NavigationRow} from "../../components/navigation/layout/nav-layout";
import {formatFnsToNow, useLanguage} from "../../components/configuration/configuration";
import {fs_regular, PersonTimesIcon} from "../../components/navigation/icons/nav-icons";


const PendingAskedEntry = ({chatEntry, onCancelRequest}) => {
    const Lang = useLanguage();

    const {friend} = chatEntry;
    const homespace = `/${friend.username}/home`;

    return <NavigationRow key={friend.id} className='friends-generic-entry'>
        <NavigationGroup>
            <UserBoxedLink grayscale
                          waiting={true}
                          to={homespace}
                          text={formatFnsToNow(chatEntry.created)}
                          user={friend}/>
        </NavigationGroup>

        <NavigationGroup>
            <WavesTooltipBounded circle title={Lang.chat.askedRequest.cancel(friend.firstname)}
                                 className='generic-navigation-button' onClick={onCancelRequest}>
                <PersonTimesIcon size={fs_regular} aria-hidden="true"/>
            </WavesTooltipBounded>
        </NavigationGroup>
    </NavigationRow>
};

export default PendingAskedEntry;